import { render } from "./ChannelList.vue?vue&type=template&id=479c2800&scoped=true"
import script from "./ChannelList.vue?vue&type=script&lang=js"
export * from "./ChannelList.vue?vue&type=script&lang=js"

import "./ChannelList.vue?vue&type=style&index=0&id=479c2800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479c2800"]])

export default __exports__